module.exports = __webpack_public_path__ + "img/homeBannerMobile.fec46372.svg";